import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Header from './Header';
import TcModal from '../TechnicalControl';
import { getColumns, DEFAULTSORTED, DEFAULTPAGESIZE } from './table.conf.js';
import { updateInPath, nullsToStrings, } from '../../../../common/utils';
import { Dimmer } from 'semantic-ui-react';


class TechnicalControl extends Component {
  constructor(props) {
    super();

    this.state = {
      tcModal: {
        opened: false,
        data: []
      },
      dimmer: false
    };
  }

  handleTcModalClose = (refreshData) => {
    this.setState(s => updateInPath(s, 'tcModal.opened', false));
  }

  handleTcModalSave = (data) => {
    this.setState(s => updateInPath(s, 'tcModal.opened', false));
    this.props.onTechnicalControlSave(data);
  };

  handleTcModalOpen = async ({ teamId, competitionId }) => {
    this.setState(s => updateInPath(s, 'dimmer', true));
    const tc = await this.props.onTechnicalControlView(teamId, competitionId);

    const d = tc ? tc : {
      teamId: teamId,
      competitionId: competitionId,
      status: 'NA',
      comments: '' };

    this.setState(s => updateInPath(s, 'tcModal.data', nullsToStrings(d)));
    this.setState(s => updateInPath(s, 'tcModal.opened', true));
    this.setState(s => updateInPath(s, 'dimmer', false));
  }

  render() {
    const { data, refresh, loading } = this.props;
    const { tcModal, dimmer } = this.state;
    
    return (
      <div>
        <Dimmer inverted active={dimmer} />
        { tcModal.opened && <TcModal
                                open={tcModal.opened}
                                data={tcModal.data}
                                onSave={this.handleTcModalSave}
                                onClose={this.handleTcModalClose} />}
        <Header disabled={loading} onSubmit={refresh} />
        <ReactTable
          filterable
          className='-striped -highlight'
          data={data}
          loading={loading}
          getTrProps={(state, rowInfo, column) => ({
            onClick: e => this.handleTcModalOpen(rowInfo.original)
          })}
          columns={getColumns()}
          defaultSorted={DEFAULTSORTED}
          defaultPageSize={DEFAULTPAGESIZE}
        />
      </div>
    );
  };
};

export default TechnicalControl;



// WEBPACK FOOTER //
// ./src/private/common/components/TechnicalControls/index.js